<template>
  <v-card
    class="d-flex flex-column"
    :class="{'elevation-2':!depressed}"
    flat
    :style="'width:auto;'+(fillParent?'height:100%;':'')"
    @mouseenter="showLowerMenu=true"
    @mouseleave="showLowerMenu=false"
  >
    <vue-element-loading
      :active="loading"
      spinner="spinner"
      color="#3ba99c"
    />
    <div
      v-if="element.type != 'counter'"
      class="element-header"
    >
      <div
        style="width:83%"
        class="text-truncate"
      >
        {{ element.label }}
      </div>
      <div class="element_actions text-right pt-2 pr-2">
        <element-editer
          v-if="editable"
          :element="element"
          :data="data"
          @edit="handleUpdateElement"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                text
                icon
                small
                v-on="on"
              >
                <v-icon>mdi-settings-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit visualization</span>
          </v-tooltip>
        </element-editer>
        <v-tooltip
          v-if="removable"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn

              color="primary"
              text
              icon
              small
              v-on="on"
              @click="removeElement"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>Remove visualization</span>
        </v-tooltip>
      </div>
    </div>
    <div
      class="flex-grow-1 fill-height"
      style="overflow:hidden;"
    >
      <template v-if="!_.isEmpty(execErrors)">
        <v-alert
          v-for="(err_body,err_label, err_index) in execErrors"
          :key="err_index"
          :value="true"
          color="accent"
          type="error"
        >
          Error running query : {{ err_body }}
        </v-alert>
      </template>
      <component
        :is="'element-'+element.type"
        v-else
        fill-parent
        :class="['component '+(element.type+'_component'),fillParent?'fill-height':'']"
        :data="data"
        :options="options"
        style="height:auto;min-height:auto;"
      />
    </div>
    <div
      v-if="!preview && !isBuilding"
      class="element-footer"
    >
      <v-dialog
        v-model="fullscreen"
        max-width="70%"
        min-height="80%"
        scrollable
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            class="mb-2"
            dark
            color="primary"
          >
            <v-toolbar-title
              class="headline pl-6"
            >
              <span class="text-capitalize">{{ element.label }}</span>
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                text
                @click.native="fullscreen = false"
              >
                <v-icon
                  left
                  small
                >
                  mdi-close
                </v-icon>
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <!-- CONTENT -->
          <v-card-text style="min-height:350px;">
            <component
              :is="'element-'+element.type"
              v-if="ready"
              class="component"
              :options="options"
              :data="data"
              :style="(fillParent ?'height:100%;':'')+'overflow:auto;'"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-row

        no-gutters

        style="font-size:17px;border-top:1px solid whitesmoke;padding-top: 5px;"
      >
        <v-col
          class="text-left pl-2 caption"
          style="line-height: 26px;"
          cols="9"
        >
          <span class="mt-2"><v-icon left>mdi-clock-outline</v-icon><span style="font-size:12px;font-weight:300;">{{ updatedAtFromNow }}</span></span>
        </v-col>
        <v-fade-transition>
          <v-col
            v-show="showLowerMenu"
            cols="3"
            class="text-right pr-3"
          >
            <v-tooltip
              v-if="element.type != 'counter'"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  text
                  color="primary"
                  icon
                  v-on="on"
                  @click="goFullScreen"
                >
                  <v-icon>mdi-fullscreen</v-icon>
                </v-btn>
              </template>
              <span>View Full screen</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  text
                  color="primary"
                  icon
                  @click="getElementData"
                  v-on="on"
                >
                  <v-icon style="font-size:18px">
                    mdi-replay
                  </v-icon>
                </v-btn>
              </template>
              <span>Refresh data</span>
            </v-tooltip>
          </v-col>
        </v-fade-transition>
      </v-row>
    </div>
  </v-card>
</template>

<script>
  import VueElementLoading from 'vue-element-loading'
  import Table from './Visualizations/Table'
  import Chart from './Visualizations/Chart'
  import Counter from './Visualizations/Counter'
  import {
    VIZ_CONFIGS,
  } from './constants/VisualizationConfigs'
  import HELPER from './../../Dashboard/Views/Projects/Dashboards/helpers/helper'
  import QueryService from '../../Dashboard/Views/Projects/Dashboards/services/QueryService'
  export default {
    name: 'DashboardElement',
    components: {
      'element-editer': () => import('./ElementBuilder'),
      'vue-element-loading': VueElementLoading,
      'element-table': Table,
      'element-chart': Chart,
      'element-counter': Counter,
    },
    mixins: [HELPER],
    props: {
      fillParent: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
      depressed: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
      removable: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
      preview: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
      project: {
        required: false,
        type: String,
      },
      element: {
        required: true,
        type: Object,
      },
      isBuilding: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
      editable: {
        required: false,
        type: Boolean,
        default: () => {
          return false
        },
      },
    },
    data () {
      return {
        updatedAt: null,
        data: {
          rows: [],
          columns: [],
        },
        showLowerMenu: true,
        execErrors: {},
        options: {},
        loading: false,
        fullscreen: false,
        ready: false,
        now: null,
      }
    },
    computed: {
      updatedAtFromNow () {
        if (this.updatedAt == null || this.now == null) { return 'Currently Updating' }
        return 'Updated ' + this.$moment(this.updatedAt.subtract(10, 'seconds')).from(this.now)
      },
    },
    watch: {
      'element.options': {
        deep: true,
        handler (vn, vo) {
          // console.log(vn['Columns']['Column Parameters']['columns'])
          if (!_.isEmpty(this.element.options)) { this.options = this.element.options }
        },
      },
      // 'element.type': {
      //   deep: false,
      //   handler (vn, vo) {
      //     // this.evaluateConfig()
      //   },
      // },
    },
    mounted () {
      this.getElementData()
      var self = this
      self.now = self.$moment()
      setInterval(function () {
        self.now = self.$moment()
      }, 60000)
    },
    methods: {
      evaluateConfig (data) {
        const self = this
        if (_.isEmpty(self.options)) {
          self.options = VIZ_CONFIGS.table
          self.options.Columns['Column Parameters'].columns = self.getHeader(data.columns)
        } else if (_.isEmpty(self.options.Columns['Column Parameters'].columns)) { self.options.Columns['Column Parameters'].columns = self.getHeader(data.columns) }
      },
      handleUpdateElement (viz) {
        this.$emit('edit', viz)
      },
      getElementData () {
        const self = this
        self.ready = false
        self.loading = true
        if (_.isEmpty(self.options)) { self.options = self.element.options }
        if (self.project) {
          QueryService.exec(self, self.element.query, self.project).then(res => {
            console.log(res)
            if (res.data.error) {
              self.execErrors = res.data
            } else {
              if (self.element.is_default) { self.evaluateConfig(res.data.data) }
              self.execErrors = {}
              self.data = res.data.data
            }
          }).catch(err => {
            if (err.response) { self.execErrors = err.response.data }
          }).finally(() => {
            self.loading = false
            self.updatedAt = self.$moment()
            self.$forceUpdate()
            self.ready = true
          })
        } else {
          this.data = this.element.data
          self.updatedAt = self.$moment()
          self.$forceUpdate()
          self.ready = true
          self.loading = false
        }
      },
      goFullScreen () {
        this.fullscreen = true
      },
      removeElement () {
        this.$emit('remove')
      },
    },

  }
</script>

<style scoped>
    .element-footer * {
        font-size: 15px;
        color: #cccccc !important;
    }

    .element-header {
        font-size: 19px;
        font-weight: 300;
        text-transform: capitalize;
        border-bottom: 1px solid whitesmoke;
        padding: 12px 0px 10px 18px;
        height: 50px;
    }

    .element-footer {
      height: 50px;
        bottom: 0px;
    }

    .component.table_component {
        overflow: auto;
    }

    .component {
        overflow: hidden;
        min-height: auto !important;
        /* height: 100%; */
    }

    .element_actions {
        position: absolute;
        right: 5px;
        top: 4px;
        width: 220px;
    }
</style>
